/* NR pinch-to-zoom (2026-08-31)
   Industry-standard in-place pinch zoom for PDP gallery images: two fingers scale and
   pan the current image under the touch midpoint; releasing springs it back. Scoped to
   two-finger gestures only, so one-finger carousel swipes and page scrolling are
   untouched. While a pinch is live, touchmoves are stopped in the capture phase so
   flickity's window-bound drag tracking freezes (its drag ends harmlessly on touchend,
   which we let through). A short click-suppression window stops the tap-to-zoom
   lightbox from opening off the tail of a pinch. */
(function () {
  'use strict';
  var MAX_SCALE = 4;
  var SETTLE_MS = 220;

  function dist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.hypot(dx, dy);
  }
  function mid(t) {
    return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 };
  }

  function attach(wrapper) {
    if (wrapper.__nrPinch) return;
    wrapper.__nrPinch = true;

    var img = null;
    var active = false;
    var startDist = 0;
    var startMid = null;
    var suppressClickUntil = 0;

    function currentImg(target) {
      var item = target && target.closest ? target.closest('.product__media-item') : null;
      var el = item && item.querySelector('img');
      if (!el) {
        item = wrapper.querySelector('.product__media-item.is-selected') ||
               wrapper.querySelector('.product__media-item');
        el = item && item.querySelector('img');
      }
      return el || null;
    }

    function reset() {
      if (!img) return;
      var el = img;
      img = null;
      el.style.transition = 'transform ' + SETTLE_MS + 'ms ease';
      el.style.transform = '';
      window.setTimeout(function () {
        el.style.transition = '';
        el.style.willChange = '';
        el.style.zIndex = '';
        el.style.position = '';
      }, SETTLE_MS + 30);
    }

    wrapper.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      var el = currentImg(e.target);
      if (!el) return;
      active = true;
      img = el;
      startDist = dist(e.touches) || 1;
      startMid = mid(e.touches);
      var rect = el.getBoundingClientRect();
      el.style.transformOrigin =
        ((startMid.x - rect.left) / rect.width) * 100 + '% ' +
        ((startMid.y - rect.top) / rect.height) * 100 + '%';
      el.style.willChange = 'transform';
      el.style.position = 'relative';
      el.style.zIndex = '5';
      e.stopPropagation();
      e.preventDefault();
    }, { capture: true, passive: false });

    wrapper.addEventListener('touchmove', function (e) {
      if (!active || !img || e.touches.length < 2) return;
      var scale = Math.min(Math.max(dist(e.touches) / startDist, 1), MAX_SCALE);
      var m = mid(e.touches);
      img.style.transform =
        'translate(' + (m.x - startMid.x) + 'px,' + (m.y - startMid.y) + 'px) scale(' + scale + ')';
      e.stopPropagation();
      e.preventDefault();
    }, { capture: true, passive: false });

    wrapper.addEventListener('touchend', function (e) {
      if (!active) return;
      if (e.touches.length < 2) {
        active = false;
        suppressClickUntil = Date.now() + 400;
        reset();
        /* let this event propagate so flickity's drag state closes cleanly */
      }
    }, { capture: true, passive: true });

    wrapper.addEventListener('touchcancel', function () {
      if (!active) return;
      active = false;
      suppressClickUntil = Date.now() + 400;
      reset();
    }, { capture: true, passive: true });

    wrapper.addEventListener('click', function (e) {
      if (Date.now() < suppressClickUntil) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);

    /* Desktop trackpads deliver pinch as ctrl+wheel (Chrome/Edge/Firefox) or Safari's
       proprietary gesture events — never as touches. Same inspect-and-spring-back
       behavior, zooming around the pointer. */
    var wheelScale = 1;
    var wheelIdleTimer = null;
    function wheelReset() {
      wheelScale = 1;
      suppressClickUntil = Date.now() + 400;
      reset();
    }
    wrapper.addEventListener('wheel', function (e) {
      if (!e.ctrlKey) return; /* plain scroll passes through untouched */
      var el = img || currentImg(e.target);
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      if (!img) {
        img = el;
        var rect = el.getBoundingClientRect();
        el.style.transformOrigin =
          ((e.clientX - rect.left) / rect.width) * 100 + '% ' +
          ((e.clientY - rect.top) / rect.height) * 100 + '%';
        el.style.willChange = 'transform';
        el.style.position = 'relative';
        el.style.zIndex = '5';
      }
      wheelScale = Math.min(Math.max(wheelScale * Math.exp(-e.deltaY * 0.01), 1), MAX_SCALE);
      img.style.transition = '';
      img.style.transform = 'scale(' + wheelScale + ')';
      window.clearTimeout(wheelIdleTimer);
      wheelIdleTimer = window.setTimeout(wheelReset, 450);
    }, { capture: true, passive: false });

    /* The PhotoSwipe lightbox is retired: never let an image click/tap open it, on any
       device. (Touch devices zoom by pinching; fine pointers get click-to-zoom below.) */
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      wrapper.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.product__media-item')) {
          e.stopPropagation();
          e.preventDefault();
        }
      }, true);
    }

    /* Desktop click-to-zoom (replaces the removed PhotoSwipe lightbox): click zooms the
       image in place around the cursor, mouse movement pans while zoomed, click again
       resets. Fine-pointer devices only; capture-phase so the legacy lightbox never opens. */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var clickZoomed = false;
      var czImg = null;
      function czReset() {
        if (!czImg) return;
        var el = czImg;
        czImg = null;
        clickZoomed = false;
        el.style.transition = 'transform ' + SETTLE_MS + 'ms ease';
        el.style.transform = '';
        el.style.cursor = '';
        wrapper.removeEventListener('mousemove', czPan);
        window.setTimeout(function () {
          el.style.transition = '';
          el.style.willChange = '';
          el.style.zIndex = '';
          el.style.position = '';
          el.style.transformOrigin = '';
        }, SETTLE_MS + 30);
      }
      function czPan(e) {
        if (!czImg) return;
        var rect = wrapper.getBoundingClientRect();
        var ox = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1) * 100;
        var oy = Math.min(Math.max((e.clientY - rect.top) / rect.height, 0), 1) * 100;
        czImg.style.transformOrigin = ox + '% ' + oy + '%';
      }
      wrapper.addEventListener('click', function (e) {
        if (Date.now() < suppressClickUntil) return; /* pinch tail already handled above */
        var el = currentImg(e.target);
        if (!el || !e.target.closest('.product__media-item')) return;
        e.stopPropagation();
        e.preventDefault();
        if (clickZoomed) { czReset(); return; }
        clickZoomed = true;
        czImg = el;
        var rect = el.getBoundingClientRect();
        el.style.transformOrigin =
          ((e.clientX - rect.left) / rect.width) * 100 + '% ' +
          ((e.clientY - rect.top) / rect.height) * 100 + '%';
        el.style.willChange = 'transform';
        el.style.position = 'relative';
        el.style.zIndex = '5';
        el.style.transition = 'transform ' + SETTLE_MS + 'ms ease';
        el.style.transform = 'scale(2.25)';
        el.style.cursor = 'zoom-out';
        window.setTimeout(function () { if (czImg) czImg.style.transition = ''; }, SETTLE_MS + 10);
        wrapper.addEventListener('mousemove', czPan);
      }, true);
      wrapper.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && clickZoomed) czReset();
      });

      /* Desktop gallery: navigation = arrows + thumbnails, click = zoom only.
         No Focal/flickity APIs (its instance promise is unreliable): we simply stop
         mousedown from ever reaching the carousel on fine pointers — it can never start
         a drag or synthesize its click-next — and the injected arrows navigate by
         clicking the existing thumbnail buttons. */
      wrapper.addEventListener('mousedown', function (e) {
        if (e.target.closest && e.target.closest('.product__media-item')) e.stopPropagation();
      }, true);
      wrapper.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.target.closest && e.target.closest('.product__media-item')) e.stopPropagation();
      }, true);

      function thumbs() {
        var media = wrapper.closest('product-media');
        if (!media) return [];
        return [...media.querySelectorAll('.product__media-nav button.product__thumbnail-item, .product__media-nav .product__thumbnail-item')]
          .filter(function (t) { return t.offsetParent !== null; });
      }
      function currentThumbIndex(list) {
        var i = list.findIndex(function (t) {
          return t.getAttribute('aria-current') === 'true' || t.classList.contains('is-nav-selected') || t.classList.contains('is-selected');
        });
        return i;
      }
      function navigate(delta) {
        if (clickZoomed) czReset();
        var list = thumbs();
        if (!list.length) return;
        var i = currentThumbIndex(list);
        if (i < 0) i = 0;
        var target = list[(i + delta + list.length) % list.length];
        if (target) target.click();
      }
      function addArrows() {
        if (thumbs().length < 2) { window.setTimeout(addArrows, 600); return; }
        if (wrapper.querySelector('.nr-gallery-arrow')) return;
        ['prev', 'next'].forEach(function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nr-gallery-arrow nr-gallery-arrow--' + dir;
          b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
          b.innerHTML = dir === 'prev'
            ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
            : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
          b.addEventListener('mousedown', function (e) { e.stopPropagation(); });
          b.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            navigate(dir === 'prev' ? -1 : 1);
          });
          wrapper.appendChild(b);
        });
      }
      addArrows();
    }

    /* Safari trackpad pinch */
    var gestureBase = 1;
    wrapper.addEventListener('gesturestart', function (e) {
      var el = currentImg(e.target);
      if (!el) return;
      e.preventDefault();
      img = el;
      gestureBase = 1;
      var rect = el.getBoundingClientRect();
      el.style.transformOrigin =
        ((e.clientX - rect.left) / rect.width) * 100 + '% ' +
        ((e.clientY - rect.top) / rect.height) * 100 + '%';
      el.style.willChange = 'transform';
      el.style.position = 'relative';
      el.style.zIndex = '5';
    }, true);
    wrapper.addEventListener('gesturechange', function (e) {
      if (!img) return;
      e.preventDefault();
      var s = Math.min(Math.max(gestureBase * e.scale, 1), MAX_SCALE);
      img.style.transition = '';
      img.style.transform = 'scale(' + s + ')';
    }, true);
    wrapper.addEventListener('gestureend', function (e) {
      if (!img) return;
      e.preventDefault();
      suppressClickUntil = Date.now() + 400;
      reset();
    }, true);
  }

  function init() {
    document.querySelectorAll('product-media .product__media-list-wrapper').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
